module.exports = __webpack_public_path__ + "img/sponsor-carousel-gateway.4ea4de53.jpg";